var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column h-100" },
    [
      _c(
        "div",
        { staticClass: "d-flex mb-2" },
        [
          _c("input-debounced", {
            attrs: { clearable: "", autofocus: true, placeholder: "Search" },
            model: {
              value: _vm.filters.search,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "search", $$v)
              },
              expression: "filters.search",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("permission-list", { attrs: { items: _vm.filtered } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }